<template>
  <div class="p-m-3 sp-page">
    <MockBanner>This is "Outstanding Orders" with the new columns. The other 13 enquiry reports and the 2 enquiry grids get the same columns.</MockBanner>
    <div class="sp-row">
      <h2 style="margin: 0;">Active Enquiries (sample)</h2>
      <span class="sp-spacer"></span>
      <div class="p-d-flex p-ai-center" style="gap: 8px;">
        <InputSwitch id="spGroup" v-model="groupByProject" />
        <label for="spGroup" style="margin: 0;">Group by project</label>
      </div>
      <MultiSelect v-model="siteFilter" :options="siteOptions" placeholder="Site" style="width: 14rem;" />
      <MultiSelect v-model="projectFilter" :options="projectOptions" placeholder="Project" style="width: 14rem;" />
    </div>
    <p class="sp-sub">
      New columns, after Branch: <strong>Site</strong>, <strong>Project</strong>, <strong>Role</strong> and <strong>Project Avg £</strong>. The number in brackets is how
      many quotes make up the value. Project Avg is shown on every enquiry of the job, so <strong>it is not totalled</strong> here (decision V1). Job totals are on the
      Projects report.
    </p>

    <div class="p-card p-p-3">
      <DataTable
        :value="rows"
        :autoLayout="true"
        class="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        :rowHover="true"
        :rowGroupMode="groupByProject ? 'subheader' : null"
        groupRowsBy="groupKey"
        :sortField="groupByProject ? 'groupKey' : null"
        :sortOrder="1"
      >
        <template #groupheader="s">
          <strong>{{ s.data.groupKey }}</strong>
        </template>
        <Column field="quoteNo" header="Quote No" :sortable="!groupByProject" />
        <Column field="customer" header="Customer Name" :sortable="!groupByProject" />
        <Column field="description" header="Description" :sortable="!groupByProject" />
        <Column field="branch" header="Branch" :sortable="!groupByProject" />
        <Column field="siteName" header="Site" :sortable="!groupByProject" headerClass="sp-new-col">
          <template #body="s"><span :class="s.data.siteName ? 'sp-link' : 'sp-muted'" @click="s.data.siteId && $router.push('/sitesProjects/sites/' + s.data.siteId)">{{ s.data.siteName || 'No project' }}</span></template>
        </Column>
        <Column field="projectName" header="Project" :sortable="!groupByProject" headerClass="sp-new-col">
          <template #body="s"><span v-if="s.data.projectName" class="sp-link" @click="$router.push('/sitesProjects/projects/' + s.data.projectId)">{{ s.data.projectName }}</span></template>
        </Column>
        <Column field="role" header="Role" :sortable="!groupByProject" headerClass="sp-new-col" />
        <Column field="avgSort" header="Project Avg £" :sortable="!groupByProject" headerClass="sp-new-col">
          <template #body="s">
            <div class="sp-money" :title="s.data.avg ? s.data.avg.basis + ' of ' + s.data.avg.n + ' quote(s) for this project and product type' : ''">
              <template v-if="s.data.avg">{{ money(s.data.avg.value) }}<span class="sp-n">({{ s.data.avg.n }})</span></template>
              <span v-else class="sp-muted">—</span>
              <span v-if="s.data.excluded" class="sp-chip dup" style="margin-left: 4px;" title="S2 duplicate: the other enquiry of the pair counts">dup</span>
            </div>
          </template>
        </Column>
        <Column field="salesExec" header="Sales Exec" :sortable="!groupByProject" />
        <Column field="grade" header="Grade" :sortable="!groupByProject" />
        <Column field="value" header="Value" :sortable="!groupByProject">
          <template #body="s"><div class="sp-money">{{ money(s.data.value) }}</div></template>
        </Column>
        <Column field="created" header="Updated Date" :sortable="!groupByProject" />
        <Column field="productType" header="Prod Type" :sortable="!groupByProject" />
        <template #footer>
          <div class="sp-row">
            <span>{{ rows.length }} enquiries</span>
            <span class="sp-spacer"></span>
            <span>Value total: <strong>{{ money(valueTotal) }}</strong> (as today)</span>
          </div>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import MockBanner from './MockBanner.vue'
import { enquiries, projectById, siteById, projectAvgFor, isLive, s2Excluded, money } from './mockData'

export default {
  name: 'SpActiveEnquiriesSample',
  components: { MockBanner },
  data() { return { groupByProject: false, siteFilter: null, projectFilter: null } },
  computed: {
    all() {
      return enquiries.filter(isLive).map(e => {
        const p = e.projectId ? projectById(e.projectId) : null
        const s = p ? siteById(p.siteId) : null
        const avg = projectAvgFor(e)
        return {
          ...e,
          siteId: s && s.id,
          siteName: s ? s.name : '',
          projectName: p ? p.name : '',
          description: e.description || (s ? (s.name + ', ' + p.name + ', ' + s.town).toUpperCase() : ''),
          avg,
          avgSort: avg ? avg.value : -1,
          excluded: s2Excluded(e),
          groupKey: p ? s.name + ' – ' + p.name : 'No project'
        }
      })
    },
    siteOptions() { return [...new Set(this.all.map(r => r.siteName || 'No project'))].sort() },
    projectOptions() { return [...new Set(this.all.filter(r => r.projectName).map(r => r.projectName))].sort() },
    rows() {
      return this.all
        .filter(r => !this.siteFilter || !this.siteFilter.length || this.siteFilter.includes(r.siteName || 'No project'))
        .filter(r => !this.projectFilter || !this.projectFilter.length || this.projectFilter.includes(r.projectName))
    },
    valueTotal() { return this.rows.reduce((a, r) => a + (r.value || 0), 0) }
  },
  methods: { money }
}
</script>

<style scoped>
@import './sitesProjects.css';
::v-deep .sp-new-col { background: #e8f5e9 !important; }
</style>
